export const NOTION_PROPERTY_TYPE_TITLE = 'title';
export const NOTION_PROPERTY_TYPE_RICH_TEXT = 'rich_text';
export const NOTION_PROPERTY_NUMBER = 'number';
export const NOTION_PROPERTY_SELECT = 'select';
export const NOTION_PROPERTY_MULTI_SELECT = 'multi_select';
export const NOTION_PROPERTY_DATE = 'date';
export const NOTION_PROPERTY_URL = 'url';
export const NOTION_PROPERTY_CHECKBOX = 'checkbox';
export const NOTION_PROPERTY_EMAIL = 'email';
export const NOTION_PROPERTY_STATUS = 'status';
export const NOTION_PROPERTY_PHONE_NUMBER = 'phone_number';
